<!-- 机构动态 -->
<template>
  <!-- <component :is="newsComponent" :key="newsId"> -->
    <banner></banner>
    <div class="container">
        <Banner/>
    <div class="mynews">
      <!-- 新闻 -->
      <div class="newsbody">
        <div class="body1">
          <v-card v-for="news in company_news" :key="news.id" class="news-card">
            <v-card-actions>
              <router-link :to="{ name: 'NewsDetail1', params: { id: news.id }}">
                <!-- <router-link :to="'/NewsDetail/:id'"> -->
                <div class="dy">
                  <div class="news-list">
                    <div v-if="news.picture" class="news-img">
                      <img class="news-picture" :src="news.picture" alt />
                    </div>
                    <!-- <div class="pp-tt1"> -->
                    <div :key="index" :class="news.picture?'dy-tt':'dy-tt1'">
                      <div class="dy-title">
                        <v-card-title v-text="news.title"></v-card-title>
                      </div>
                      <div class="dy-text">
                        <v-card-text v-html="news.content"></v-card-text>
                      </div>
                      <div class="dy-bo">
                        <div class="dy-company">
                          <!-- <div class="dy-bo1"> -->
                          <div class="dy-bo1-2">
                            <p class="dy-bo1-text">公司</p>
                          </div>
                          <div class="news-company">
                            <div>
                              <img class="company-img" :src="news.company.avatar" alt />
                            </div>
                            <div class="company-name">{{ news.company.name }}</div>
                          </div>
                        </div>
                        <div class="dy-bo2">
                          <div style="flex: 1;margin: 0">
                            <v-card-subtitle v-text="news.user.username"></v-card-subtitle>
                          </div>
                          <div style="margin: 0;">
                            <p>发布于</p>
                          </div>
                          <div style="margin: 0">
                            <v-card-subtitle v-text="news.time_since_created"></v-card-subtitle>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </router-link>
            </v-card-actions>
          </v-card>
        </div>

        <!-- 实时热榜 -->
        <div class="body2">
          <p class="newsTitle">热点动态</p>
          <div class>
            <div v-for="(news,index) in company_news">
              <v-card-actions class>
                <router-link :to="{ name: 'NewsDetail1', params: { id: news.id }}">
                  <div class="hotList-text">
                    <div class="dy-hot-title">{{ formatTitle(news.title) }}</div>

                    <div class="hot-text">
                      <v-card-text v-html="news.content"></v-card-text>
                    </div>

                    <div class="company">
                      <div>
                        <img class="company-img" :src="news.company.avatar" alt />
                      </div>
                      <div class="company-name">{{ news.company.name }}</div>
                    </div>
                  </div>
                </router-link>
              </v-card-actions>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </component> -->
</template>
    
    
<script >
import {
  getCompanyNews,
  getLogin
} from "@/api/api";
    import banner from '@/views/layout/components/banner.vue'

    
    export default {
    

  components: {
    banner
  },
  data() {
    return {
      news_value: "",
      company_news: "",
      hot_news: "",
      login: ""
    };
  },
  computed: {
    newsComponent() {
      // 假设每个新闻的详情组件都遵循 'NewsDetail{id}' 的命名约定
      return `Newsdetail${this.newsId}`;
    }
  },
  watch: {},
  methods: {
    change() {
      console.log(this.news_value);
    },
    readMore(url) {
      window.open(url);
    },

    async getInfo() {
      const res = await getCompanyNews();
      this.company_news = res.results.map(news => ({
        id: news.id,
        title: news.title,
        content: news.content,
        created_at: news.created_at,
        company: {
          id: news.company.id,
          name: news.company.name,
          avatar: news.company.avatar
        },
        user: {
          id: news.user.id,
          username: news.user.username
        },
        picture: news.picture,
        time_since_created: news.time_since_created
      }));
      console.log(this.company_news);
    },
    // async getInfo1(){
    //   const res = await getLogin()
    //   this.login=res;
    //   console.log(res)
    // }
    formatTitle(title) {
      if (!title) return "";
      return title.length > 15 ? title.slice(0, 30) + "..." : title;
    }
  },
  created() {},
  mounted() {
    this.getInfo()
      .then(() => {})
      .catch(error => {
        // 处理错误
        console.error("Error fetching data: ", error);
      });
    // this.getInfo1().then( ()=>{
    // }).catch(error => {
    //     // 处理错误
    //     console.error('Error fetching data: ', error);
    //   });
  }
};
</script>
    <style lang='scss' scoped>
@import "../dynamics/style/dynamics.css";
</style>